module.exports = __webpack_public_path__ + "img/installers.0585c2b2.svg";